import { apiFetch } from './apiClient';

export interface Scrapper {
  id: number;
  uid: number;
  prod_id: number;
  title: string;
  url: string;
  status: string;
  selector: string | null;
  color: string | null;
  stock_selector: string | null;
  dt: string;
  prod_title?: string;
}

export interface ScrapperPayload {
  prod_id: number;
  title: string;
  url: string;
  status: string;
  selector?: string;
  color?: string;
  stock_selector?: string;
}

export const scrappersService = (token: string | null) => ({
  list: (params: URLSearchParams) =>
    apiFetch<{ scrappers: Scrapper[]; total: number }>(token, `/api/scrappers?${params.toString()}`),
  create: (payload: ScrapperPayload) =>
    apiFetch(token, '/api/scrappers', { method: 'POST', body: JSON.stringify(payload) }),
  update: (id: number, payload: ScrapperPayload) =>
    apiFetch(token, `/api/scrappers/${id}`, { method: 'PUT', body: JSON.stringify(payload) }),
  updateUrl: (id: number, url: string) =>
    apiFetch(token, `/api/scrappers/${id}`, { method: 'PUT', body: JSON.stringify({ url }) }),
  remove: (id: number) =>
    apiFetch(token, `/api/scrappers/${id}`, { method: 'DELETE' }),
  bulkDelete: (ids: number[]) =>
    apiFetch(token, '/api/scrappers/bulk-delete', { method: 'POST', body: JSON.stringify({ ids }) }),
  recrawl: (id: number) =>
    apiFetch(token, `/api/scrappers/${id}/recrawl`, { method: 'POST' }),
  titles: (prodId: number) =>
    apiFetch<{ data: string[] }>(token, `/api/scrappers/titles?prod_id=${prodId}`),
});
